import React from 'react'
import EventFormField from './event_form_field';

var EventFormFieldsContainer = React.createClass({
  propTypes: {
    fields: React.PropTypes.array
  },
  render: function() {
    const { onChange, onValidateEmail, validatedMembership, fields } = this.props;
    return(
      <div className="panel">
        <div className="panel-heading">
          <div className="panel-title"> <span className="glyphicon glyphicon-user"></span> Details </div>
        </div>
        <div className="panel-body">
          { fields.map( (f) => <EventFormField key={f.name} onChange={onChange} onValidateEmail={onValidateEmail} validatedMembership={validatedMembership} { ...f} /> )}
        </div>
      </div>
    );
  }
});

export default EventFormFieldsContainer;


// WEBPACK FOOTER //
// ./src/components/event_form_fields_container.js